import apiClient from './apiClient';

const iniciarConexion = (cuil, clave) =>
    apiClient.post('/anses/conexiones', { cuil, clave }).then((r) => r.data);

// Plan B: solo se llama cuando el intento automático de iniciarConexion() terminó en ERROR.
const iniciarConexionManual = (cuil) =>
    apiClient.post(`/anses/conexiones/${cuil}/manual`).then((r) => r.data);

const pollLoginSesion = (sessionId) =>
    apiClient.get(`/anses/conexiones/login-sesion/${sessionId}`).then((r) => r.data);

const obtenerEstado = (cuil) =>
    apiClient.get(`/anses/conexiones/${cuil}`).then((r) => r.data);

const ansesConexionService = { iniciarConexion, iniciarConexionManual, pollLoginSesion, obtenerEstado };

export default ansesConexionService;
